import { parseQuery, serializeQuery } from '../lib/urlQuery.js';

export default {
    name: 'searchmanager',
    dependencies: ['radio', 'xhrservice'],
    callable(radio, xhr) {
        function FinnSearcher() {
            // fixme: le hack!
            const searchUrl = window.location.href.replace('.html', '.json');
            const url = new URL(searchUrl);
            url.hash = '';
            this.searchUrl = searchUrl;
            this.page = parseInt(url.searchParams.get('page'), 10) || 1;
            this.savedSearchId = parseInt(
                url.searchParams.get('stored-id'),
                10
            );
            this.searchParamsChanged = false;
            this.SORT_GEO = '99';
            if (isNaN(this.savedSearchId)) {
                this.savedSearchId = undefined;
            }

            if (url.searchParams.get('sort')) {
                this.sortBy = {
                    value: url.searchParams.get('sort'),
                    lat: url.searchParams.get('lat'),
                    long: url.searchParams.get('lon'),
                };
            }

            this.currentQuery = parseQuery(url.search);

            url.search = '';
            this.baseUrl = url.toString();
        }

        FinnSearcher.prototype = {
            _canceler: null,

            listToMultiMap(list) {
                const ret = {};
                list.forEach(e => {
                    if (ret.hasOwnProperty(e.name)) {
                        ret[e.name].push(e.value);
                    } else {
                        ret[e.name] = [e.value];
                    }
                });
                return ret;
            },

            search(args, page) {
                this.searchParamsChanged = true;
                this.page = page === undefined ? this.page : page;
                if (Array.isArray(args)) {
                    args = this.listToMultiMap(args);
                }

                this.currentQuery = args;

                // FIXME: make this more general. We should just keep all the query arguments
                // unless they're in a blacklist.
                if (this.sortBy != null) {
                    args.sort = [this.sortBy.value];
                    if (!args.lat && this.sortBy.lat) {
                        args.lat = [this.sortBy.lat];
                    }
                    if (!args.lon && this.sortBy.long) {
                        args.lon = [this.sortBy.long];
                    }
                }

                if (
                    !args.radius &&
                    (!this.sortBy || this.sortBy.value !== this.SORT_GEO)
                ) {
                    delete args.lat;
                    delete args.lon;
                    delete args.geoLocationName;
                }
                if (!args.lon || !args.lat) {
                    delete args.radius;
                    delete args.geoLocationName;
                }

                if (this.page && this.page !== 1) {
                    args.page = [this.page];
                } else {
                    delete args.page;
                }

                const url = new URL(document.baseURI);
                if (url.searchParams.has('filters')) {
                    args.filters = [];
                } else {
                    delete args.filters;
                }

                const orgId = url.searchParams.get('orgId');
                if (orgId) {
                    args.orgId = [orgId];
                } else {
                    delete args.orgId;
                }

                radio('network').broadcast(true);

                if (this._canceler) {
                    this._canceler();
                }
                this._canceler = xhr.canceler();

                const promise = xhr.request({
                    data: args || {},
                    url: this.baseUrl,
                    type: 'json',
                    canceler: this._canceler,
                    timeout: 30000,
                });

                this._setSearchUrl(args);

                return promise.then(
                    this.onSuccess.bind(this),
                    this.onError.bind(this)
                );
            },

            onSuccess(response) {
                // response == null happens on e.g. abort(), see xhrservice
                if (!response) {
                    return null;
                }
                radio('network').broadcast(false);
                const query = parseQuery(
                    new URL(response.selfUrl, document.baseURI).search
                );
                delete query.rows;
                delete query.abTestKey;
                delete query.userId;
                this.currentQuery = query;
                this._setSearchUrl(query);
                radio('searchUrl.updated').broadcast();
                return new FinnSearchResult(response);
            },

            onError(error) {
                radio('network').broadcast(false);
                throw error;
            },

            // repeat current search with a new sort order
            sort(by) {
                this.sortBy = by;
                return this.search(this.currentQuery, 1);
            },

            setPage(index) {
                this.page = index;
                return this.search(this.currentQuery);
            },

            getSearchParams() {
                const url = new URL(document.baseURI);
                const pathSegments = url.pathname.split('/').filter(e => e);
                pathSegments.pop();

                let segmentextension = '';
                if (pathSegments.length > 2) {
                    segmentextension = `/${pathSegments.pop()}`;
                }

                const searchId = url.searchParams.get('stored-id');
                const args = parseQuery(url.search);
                url.searchParams.delete('search-id');

                return {
                    segment: pathSegments.pop() + segmentextension,
                    vertical: pathSegments.pop(),
                    args,
                    searchId,
                };
            },

            _setSearchUrl(args) {
                const searchUrl = new URL(this.baseUrl);
                searchUrl.search = serializeQuery(args);
                this.searchUrl = searchUrl.href;
            },
        };

        function FinnSearchResult(data) {
            this.filterWidgets = data.filterWidgets;
            this.hits = data.hits;
            this.searchVersion = data.searchVersion;
            this.objectCount = data.objectCount;
            this.segment = data.segment;
            this.title = data.title;
            this.subTitle = data.subTitle;
            this.displaySearchResults = data.displaySearchResults;
            this.sortValues = data.sortValues;
            this.prevResult = data.prevResult;
            this.nextResult = data.nextResult;
            this.firstResult = data.firstResult;
            this.showFirstPagingLink = data.showFirstPagingLink;
            this.showCurrentPagingIndex = data.showCurrentPagingIndex;
            this.pagingInfo = data.pagingInfo;
            if (this.pagingInfo) {
                this.page = this.pagingInfo.currentPageIndex;
            }
            this.url = data.selfUrl;
            this.mapUrl = data.mapUrl;
            this.bannerData = data.bannerData;
            this.topboard = data.topboard;
            this.hasGridLayout = data.hasGridLayout;
            this.hasListLayout = data.hasListLayout;
            this.showSaveSearchTeaser = data.showSaveSearchTeaser;
            this.isSearchStorable = data.isSearchStorable;
            this.bapResultPageGridEnabled = data.bapResultPageGridEnabled;
            this.showDistance = data.showDistance;
            this.uuid = data.uuid;
            this.isRealestateGridViewPriceToggle =
                data.isRealestateGridViewPriceToggle;
        }

        return new FinnSearcher();
    },
};



// WEBPACK FOOTER //
// ./services/searchmanager.js